var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tasks)?_c('div',[_c('transition-group',{attrs:{"name":"post-list"}},_vm._l((_vm.tasks),function(task){return _c('post-item',{key:task.id,attrs:{"task":task,"checked":task.complete},on:{"remove":function($event){return _vm.$emit('remove', task.id)},"checkIt":function($event){return _vm.checkIt(task.id)}}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }